/**定制按钮 demo  目前定制取消不需要再调研 */
import fvSubassembly from "../fvSubassembly";
export default class fvRect extends fvSubassembly {
    constructor(sContent,parent,system,callback){
        super(sContent,parent,system);
        this.create();
        if(this.isDelayedWaiting){
            this.complete = callback;
        }else{
            callback(this);
        }

        this.createSucss();
    }
    init(){
        super.init();
        if(this.originalSize.width/(this.frameScaleX+1) >= 2){
          this.width -= 1;
        }
        this.moveWidth = this.borderWidth/2;
    }
    onDraw(canvas){
        if(!this.fcHide) return;
        if(this.height == 0 || this.width == 0) return
        this.formatRect();
        this.executePreAnimation(canvas);
        canvas.beginPath();
        canvas.canvas["type"]='button';
        canvas.save();
        //矩形填充使用
        this.regionHeight = this.height -  this.borderWidth;
        this.regionWidth = this.width -  this.borderWidth;
        
        if(this.lineType >= 1){
            canvas.setLineDash(this.lineStyle(this.lineType));
        }
        if(this.color=="" || this.opacity<=0){
            canvas.fillStyle = "rgba(255, 255, 255, 0)";//矩形填充透明
        }else{
            var rgbArray = this.color.colorRgb(this.opacity/255);;
            canvas.fillStyle = rgbArray;//矩形填充颜色
        }
        if(this.borderWidth == 0){
            canvas.strokeStyle = rgbArray;
        }else{
            canvas.strokeStyle = this.borderColor;//边框颜色
        }
        //设置线宽度
        if(this.borderWidth == 0){
            canvas.lineWidth = 0.01;
        }else{
            canvas.lineWidth = this.borderWidth;
        }
        this.roundRect(canvas,this.cx,this.cy,this.width,this.height,this.changeGrond(),1); //实心圆角矩形
        this.roundRect(canvas,this.cx,this.cy,this.width,this.height,this.changeGrond(),0); //空心圆角矩形
        this.align = "r";
        this.verticalDisplay = true;//横竖
        var rgbArray = this.color.colorRgb(this.opacity/255);
        this.color = rgbArray ;//背景色
        canvas.font="italic bolder 12px System";
        canvas.fillStyle= "#ccc";//字体颜色
        var text = "按22钮";

        var textLeng = canvas.measureText(text);
        var size = canvas.font.substring(canvas.font.indexOf("px")-2,canvas.font.indexOf("px"));//字体大小
        if(this.verticalDisplay){

        }else{

        }
        if(this.align == "center"){
            var x = this.cx+this.width/2-textLeng.width/2 ;
            var y = this.cy+this.height/2+size/2;
        }else if(this.align == "left"){
            var x = this.cx;
            var y = this.cy+this.height/2+size/2;
        }else{
            var x = this.cx+this.width-textLeng.width;
            var y = this.cy+this.height/2+size/2;
        }
        canvas.fillText(text, x , y);//文本
        
        canvas.fillRect(x , y, textLeng.width, 2); //下划线
        canvas.stroke();

        this.Render(canvas);
        this.executePosAnimation(canvas);
        canvas.stroke();
        canvas.restore();

        
    }
    Render(canvas) {
        var SIN_COS_API=3.141592625;
        var rd = this.renderConfig;
        var m_fRotate = SIN_COS_API/180 * parseFloat(0); //跟draw的精度一样
        if(rd.color){
            var colorNum = rd.color.length;
        }
        var rect = {
            left : this.cx,
            top : this.cy,
            bottom : parseFloat(this.cy + this.regionHeight),
            right :parseFloat(this.cx + this.regionWidth),
            width : parseFloat(this.width),
            height : parseFloat(this.height)
        }
        if(this.render){
            // this.render.rend(canvas,rect,this);
            switch (this.renderType){
                case 1:  //模式1
                    this.render.rend(canvas,rect,rd.grade,"",rd.color,colorNum,rd.colorGrade,m_fRotate);
                    break;
                case 2:  //模式2
                    this.render.rend(canvas,rect,rd.grade,"",rd.color,colorNum,rd.colorGrade,m_fRotate,rd.rendShape,rd.centerPos,rd.rotate);
                    break;
                case 3:  //模式3
                    this.render.rend(canvas,this,this.color,rd.grade);
                    break;
                case 4:  //canvas线性渐变效果
                case 5:  //canvas路径渐变效果
                case 6:  //canvas纹理渐变效果
                    this.render.rend(canvas,rect,this);
                default:
                    break;
            }
        }
    }
    roundRect(canvas,x, y, w, h, r,flag) {
        //圆半径不能为负数
        if(parseFloat(r)<0){
            r = 0.1;
        }
        canvas.beginPath();
        canvas.moveTo(parseFloat(x)+parseFloat(r), parseFloat(y));
        canvas.arcTo(parseFloat(x)+parseFloat(w), parseFloat(y), parseFloat(x)+parseFloat(w), parseFloat(y)+parseFloat(h), parseFloat(r));
        canvas.arcTo(parseFloat(x)+parseFloat(w), parseFloat(y)+parseFloat(h), parseFloat(x), parseFloat(y)+parseFloat(h), parseFloat(r));
        canvas.arcTo(parseFloat(x), parseFloat(y)+parseFloat(h), parseFloat(x), parseFloat(y), parseFloat(r));
        canvas.arcTo(parseFloat(x), parseFloat(y), parseFloat(x)+parseFloat(w), parseFloat(y), parseFloat(r));
        canvas.closePath();
        if(flag == 1){
            canvas.fill();
        }else{
            canvas.stroke();
        }
    }
    //判断如果圆角最大值不能超过宽高的一半
    changeGrond(){
        if(this.round[0]*2 > this.width || this.round[0]*2 > this.height){
            var widthHeight = this.width > this.height?this.height:this.width;
            this.round[0] = widthHeight/2;
        }
        return this.round[0];
    }
    /*16进制颜色转为RGBA格式*/
    hexToRgba(hex, opacity) {
        return "rgba(" + parseInt("0x" + hex.slice(1, 3)) + "," + parseInt("0x" + hex.slice(3, 5)) + "," + parseInt("0x" + hex.slice(5, 7)) + "," + opacity + ")";
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/fvButtonObj.js